var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_warp auto"},[_c('button',{on:{"click":function($event){return _vm.goMiniPage('/pages/shop/index')}}},[_vm._v("旧版商城")]),_c('button',{on:{"click":function($event){return _vm.goMiniPage('/pagesMall/index')}}},[_vm._v("新版商城")])])
}
var staticRenderFns = []

export { render, staticRenderFns }